import normalize from "json-api-normalizer";
import { camelizeKeys } from "humps";
import _ from "lodash";
import store from "@/store/index";
import { fetchPatientQueueToken } from "../helpers/patient_queue_token";
import BaseService from "./BaseService";

export default {
  published(keyword) {
    return BaseService.get(`interviews/published/${keyword}`)
      .then((response) => {
        const data = normalize(response.data);
        // normalize doesn't traverse deep enough when camelizing keys, so we have to do it manually
        if (data.interviewPages) {
          _.forEach(Object.keys(data.interviewPages), (key) => {
            data.interviewPages[key].attributes = camelizeKeys(
              data.interviewPages[key].attributes
            );
          });
        }
        if (data.interviewAlternateEndings) {
          _.forEach(Object.keys(data.interviewAlternateEndings), (key) => {
            data.interviewAlternateEndings[key] = camelizeKeys(
              data.interviewAlternateEndings[key].attributes
            );
          });
        }

        store.dispatch("interview/set", data);
        store.dispatch("interview/setPreview", false);
      })
      .catch((errors) => Promise.reject(errors));
  },

  preview(id) {
    return BaseService.get(`interviews/preview/${id}`)
      .then((response) => {
        const data = normalize(response.data);
        // normalize doesn't traverse deep enough when camelizing keys, so we have to do it manually
        _.forEach(Object.keys(data.interviewPages), (key) => {
          data.interviewPages[key].attributes = camelizeKeys(
            data.interviewPages[key].attributes
          );
        });
        if (data.interviewAlternateEndings) {
          _.forEach(Object.keys(data.interviewAlternateEndings), (key) => {
            data.interviewAlternateEndings[key] = camelizeKeys(
              data.interviewAlternateEndings[key].attributes
            );
          });
        }
        store.dispatch("interview/set", data);
        // TODO dry up normalize above
        store.dispatch("interview/setPreview", true);
      })
      .catch((errors) => Promise.reject(errors));
  },

  update(interview_id, patient_queue_id, answers, path) {
    let token = fetchPatientQueueToken();
    return BaseService.patch("answers", {
      token,
      interview_id: interview_id,
      id: patient_queue_id,
      path,
      answers,
    })
      .then((response) => {
        let status = false;
        if (response.status === 200) {
          status = true;
        }
        return status;
      })
      .catch((errors) => Promise.reject(errors));
  },

  finish_and_create_async_case(
    interview_id,
    patient_queue_id,
    answers,
    refer,
    organizationId
  ) {
    return this.finish(
      interview_id,
      patient_queue_id,
      answers,
      refer,
      null,
      null,
      null,
      1,
      organizationId
    );
  },

  // TODO: This function signature is a mess. Refactor it at some point
  finish(
    interview_id,
    patient_queue_id,
    answers,
    refer,
    onDemandSession,
    interviewAlternateEndingId,
    onDemandEndingId,
    createAsyncCase,
    organizationId
  ) {
    let token = fetchPatientQueueToken();
    return BaseService.patch("answers", {
      token,
      interview_id: interview_id,
      patient_queue_id: patient_queue_id,
      answers,
      refer,
      on_demand_session: onDemandSession,
      interview_alternate_ending_id: interviewAlternateEndingId,
      ondemand_ending_id: onDemandEndingId,
      finished: true,
      create_async_case: createAsyncCase,
      organization_id: organizationId,
    })
      .then((response) => {
        let submitted = false;
        if (response.status === 200) {
          submitted = true;
        }
        return { submitted, response };
      })
      .catch((errors) => Promise.reject(errors));
  },

  extras(patientId) {
    return BaseService.get(`interviews/extras/${patientId}`)
      .then((response) => {
        store.dispatch("interview/setExtras", camelizeKeys(response.data));
      })
      .catch((errors) => Promise.reject(errors));
  },
};
